const productList = document.querySelectorAll('.product-grid-item');

  productList.forEach( product => {
    
    const siblingLink = product.querySelectorAll('.siblings__link');

    const unitPrice = product.querySelector('.price');
    const cutline = product.querySelector('.product__grid__cutline');
    
    siblingLink.forEach( item =>{

      const siblingPrice = item.dataset.price;
      const siblingCutline = item.dataset.cutline;
      
      item.addEventListener('click', () => {
        unitPrice.textContent = siblingPrice;
        cutline.textContent = siblingCutline;
      });
    })
    
  })
